import type { TelanganaDistrictKey } from "./telanganaDistricts";
import hotspots from "./telanganaGovHotspots.json";

/** Image map titles on https://www.telangana.gov.in/about/districts/ → app district keys */
const TITLE_TO_KEY: Record<string, TelanganaDistrictKey> = {
  Adilabad: "adilabad",
  "Kumuram Bheem": "komaram_bheem_asifabad",
  Nirmal: "nirmal",
  Mancherial: "mancherial",
  Nizamabad: "nizamabad",
  Jagital: "jagtial",
  Peddapalli: "peddapalli",
  Kamareddy: "kamareddy",
  "Rajanna Sircilla": "rajanna_sircilla",
  Karimnagar: "karimnagar",
  Jayashankar: "jayashankar_bhupalpally",
  Sangareddy: "sangareddy",
  Medak: "medak",
  Siddipet: "siddipet",
  Hanumakonda: "hanumakonda",
  Mulugu: "mulugu",
  "Medchal-Malkajgiri": "medchal_malkajgiri",
  "Yadadri Bhuvanagiri": "yadadri_bhuvanagiri",
  Jangaon: "jangaon",
  Warangal: "warangal",
  Mahabubabad: "mahabubabad",
  "Bhadradri Kothagudem": "bhadradri_kothagudem",
  Khammam: "khammam",
  Hyderabad: "hyderabad",
  Vikarabad: "vikarabad",
  Rangareddy: "rangareddy",
  Nalgonda: "nalgonda",
  Suryapet: "suryapet",
  Naryanpet: "narayanpet",
  Mahabubnagar: "mahbubnagar",
  Nagarkurnool: "nagarkurnool",
  Wanaparthy: "wanaparthy",
  "Jogulamba Gadwal": "jogulamba_gadwal",
};

export const TELANGANA_GOV_MAP_WIDTH = 1879;
export const TELANGANA_GOV_MAP_HEIGHT = 1897;

export type GovHotspotRow = {
  title: string;
  d: string;
  key: TelanganaDistrictKey;
};

export const TELANGANA_GOV_HOTSPOTS: GovHotspotRow[] = (hotspots as { title: string; d: string }[])
  .map((h) => {
    const key = TITLE_TO_KEY[h.title];
    return key ? { title: h.title, d: h.d, key } : null;
  })
  .filter((x): x is GovHotspotRow => x !== null);

/** Pastel fills to distinguish neighbours (choropleth-style base layer). */
export const DISTRICT_FILL_PALETTE = [
  "#dbeafe",
  "#fce7f3",
  "#d1fae5",
  "#fef3c7",
  "#e9d5ff",
  "#fed7aa",
  "#cffafe",
  "#fecaca",
  "#ddd6fe",
  "#a7f3d0",
  "#fde68a",
  "#bfdbfe",
  "#fbcfe8",
  "#bbf7d0",
  "#fde047",
  "#e0e7ff",
  "#fecdd3",
  "#99f6e4",
  "#fcd34d",
  "#c4b5fd",
  "#86efac",
  "#fdba74",
  "#bae6fd",
  "#f9a8d4",
  "#a5f3fc",
  "#fca5a5",
  "#c7d2fe",
  "#fde047",
  "#6ee7b7",
  "#fdba74",
  "#93c5fd",
  "#f0abfc",
  "#5eead4",
] as const;

/** Lighter fills so mandal subdivisions read clearly on top of a district base. */
export const MANDAL_FILL_PALETTE = [
  "#ffffff",
  "#f8fafc",
  "#f1f5f9",
  "#e8eef4",
  "#e2e8f0",
  "#dbeafe",
  "#ede9fe",
  "#fce7f3",
  "#d1fae5",
  "#fef3c7",
  "#cffafe",
  "#fecaca",
  "#ddd6fe",
  "#bbf7d0",
  "#fde68a",
] as const;
